module.exports = function () {
    var $ = require('jquery');
$(function() {
    if ($('.genre-landing--industry-resources #algolia-search-box').length > 0 || $('.genre-landing #algolia-search-box').length > 0) {
        
        var algoliaIndexName = 'wp_searchable_posts_genre';
        if( true === $('body').hasClass('term-events') ){
            if (algolia.indices.posts_event === undefined && $('.admin-bar').length > 0) {
                alert('It looks like you haven\'t indexed the searchable posts index. Please head to the Indexing page of the Algolia Search plugin and index it.');
            }
            algoliaIndexName = algolia.indices.posts_event.name;
        }
        if (algolia.indices.searchable_posts === undefined && $('.admin-bar').length > 0) {
            alert('It looks like you haven\'t indexed the searchable posts index. Please head to the Indexing page of the Algolia Search plugin and index it.');
        }

        /* Instantiate instantsearch.js */
        var search = instantsearch({
            indexName: algoliaIndexName,
            searchClient: algoliasearch( algolia.application_id, algolia.search_api_key ),
            routing: {
                router: instantsearch.routers.history({ writeDelay: 1000 }),
                stateMapping: {
                    stateToRoute( indexUiState ) {
                        return {
                            s: indexUiState[ algoliaIndexName ].query,
                            page: indexUiState[ algoliaIndexName ].page
                        }
                    },
                    routeToState( routeState ) {
                        const indexUiState = {};
                        indexUiState[ algoliaIndexName ] = {
                            query: routeState.s,
                            page: routeState.page
                        };
                        return indexUiState;
                    }
                }
            },                  
        });

		// Reuse
		const noResultsTemplate = `
		<div class="col-xs-12">
			<div class="no-results">
			Sorry, we didn't find any results for "<span class="bold">{{query}}</span>"
				<div class="col-xs-12 heading">Tips:</div>
				<div class="col-xs-12">
					<ul>
						<li>Double-check your spelling</li>
						<li>Try searching for a term that is less specific</li>
						<li>Use different keywords</li>
					</ul>
					<div class="col-xs-12 col-lg-6 text-center">
						<a href="javascript:void(0);" class="btn outline ais-clear-all--link">Clear Search</a>
					</div>
				</div>
			</div>
		</div>
		`

		const itemMarkup = `
					<a class="{{cssClasses.link}}" href="{{url}}">
						<span class="{{cssClasses.label}}">{{label}}</span>
						<span class="{{cssClasses.count}}">
						({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})
						</span>
					</a>
					`

        search.addWidgets([

            /* Configure Results */
            instantsearch.widgets.configure({
                facets: [
                    'genre'
                ],
                filters: "taxonomies.genre:'" + irAttributes.genre_name + "'",
                facetingAfterDistinct: true
            }),

            /* Search box widget */
            instantsearch.widgets.searchBox({
                container: '#algolia-search-box',
                placeholder: 'Search...',
                showReset: true,
                showSubmit: false,
                showLoadingIndicator: false,
                wrapInput: false,
                cssClasses: {
                    resetIcon: [
                        'ais-clear-all--link'
                    ]
                    }
            }),

            /* Stats widget */
            instantsearch.widgets.stats({
                container: '#algolia-stats',
                autoHideContainer: true
            }),

            /* Hits widget */
            instantsearch.widgets.hits({
                container: '#algolia-hits',
                hitsPerPage: 20,
                templates: {
                    empty: noResultsTemplate,
                    item: wp.template('instantsearch-hit')
                }
            }),

            /* Pagination widget */
            instantsearch.widgets.pagination({
                container: '#algolia-pagination'
            }),

            /* Facet: Verticals */
            instantsearch.widgets.menuSelect({
                container: '#facet-vertical',
                attribute: 'taxonomies.vertical',
                limit: 50,
                templates: {
                    item: itemMarkup
                }
            }),

        ]);

        /* Start */
        search.start();

        $( '#algolia-search-box input' ).attr( 'type', 'search' ).trigger( 'select' );

    }
    })
};